import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caidan",
  "use": "icon-caidan-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caidan\">\r\n<line x1=\"0.7\" y1=\"0.700024\" x2=\"17.3\" y2=\"0.700024\" stroke=\"#999999\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\r\n<line x1=\"0.7\" y1=\"6.70002\" x2=\"17.3\" y2=\"6.70002\" stroke=\"#999999\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\r\n<line x1=\"0.7\" y1=\"12.7\" x2=\"17.3\" y2=\"12.7\" stroke=\"#999999\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol